import React, { useMemo } from "react";

import ProjectTable from "pages/components/ProjectTable/ProjectTable";
import MaterialImage from "pages/components/MaterialImage";

function AnaliseVendasDetalheTable({ linhas, totalLinhas, metric, imgsByRef, loading = false }) {
  const columns = useMemo(() => {
    const colData = {
      Header: "Data",
      accessor: "faturadata",
      Cell: ({ value }) => {
        if (!value) return "";

        const texto = String(value);
        return texto.length >= 10 ? texto.slice(0, 10) : texto;
      },
    };

    const colFatura = {
      Header: "Nº Fatura",
      accessor: "faturanumero",
    };

    const colImg = {
      Header: "",
      id: "img",
      disableFilters: true,
      disableSortBy: true,
      Cell: ({ row }) => (
        <MaterialImage
          refMaterial={row.original.refmaterial}
          imgsByRef={imgsByRef}
          size={26}
          placeholderWidth={32}
        />
      ),
    };

    const colMaterial = {
      Header: "Material",
      id: "material",
      accessor: (row) => {
        const nome = row.nomematerial || "";
        const ref = row.refmaterial || "";

        return `${nome}${ref ? ` (${ref})` : ""}`;
      },
    };

    const colValor = {
      Header: "Valor Total",
      accessor: "valortotal",
      Cell: ({ value }) =>
        value == null
          ? ""
          : Number(value).toLocaleString("pt-PT", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }),
    };

    const colLitros = {
      Header: "Litros",
      accessor: "volume",
      Cell: ({ value }) =>
        value == null
          ? ""
          : Number(value).toLocaleString("pt-PT", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }),
    };

    const colPesoBruto = {
      Header: "Peso Bruto",
      accessor: "pesobruto",
      Cell: ({ value }) =>
        value == null
          ? ""
          : Number(value).toLocaleString("pt-PT", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }),
    };

    const colQuantidade = {
      Header: "Quantidade",
      accessor: "quantidade",
      Cell: ({ value }) =>
        value == null
          ? ""
          : Number(value).toLocaleString("pt-PT", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }),
    };

    const metricCol =
      metric === "eur"
        ? colValor
        : metric === "litros"
        ? colLitros
        : metric === "qtd"
        ? colQuantidade
        : colPesoBruto;

    const colCliente = {
      Header: "Cliente",
      accessor: "cliente",
      Cell: ({ row }) => {
        const nome = row.original.cliente || "";
        const nif = row.original.clientenif || "";

        return nif && String(nif).trim() !== "" ? `${nome} (${nif})` : nome;
      },
    };

    return [
      colData,
      colFatura,
      colImg,
      colMaterial,
      metricCol,
      colCliente,
      {
        Header: "Vendedor",
        accessor: "vendedor",
      },
      {
        Header: "Fabricante",
        accessor: "fabricante",
      },
      {
        Header: "Família",
        accessor: "familia",
      },
    ];
  }, [metric, imgsByRef]);

  const lista = Array.isArray(linhas) ? linhas : [];
  const total = Number(totalLinhas || 0);

  const title =
    total > lista.length
      ? `Detalhe das vendas (${lista.length.toLocaleString("pt-PT")} de ${total.toLocaleString(
          "pt-PT"
        )} linhas)`
      : `Detalhe das vendas (${lista.length.toLocaleString("pt-PT")} linhas)`;

  return (
    <ProjectTable
      tableKey="analise-vendas-detalhe"
      version="v1"
      title={title}
      columns={columns}
      data={lista}
      loading={loading}
      emptyMessage="Sem dados com os filtros selecionados."
      minWidth={1450}
      maxHeight="58vh"
      defaultSortBy={[
        {
          id: "faturadata",
          desc: true,
        },
      ]}
      showKeepFilters
    />
  );
}

export default AnaliseVendasDetalheTable;
